"use client";

import { useEffect } from "react";
import api from "../../services/api";

export default function PaymentListener() {
  useEffect(() => {
    const handler = async (e) => {
      if (!e?.detail) return;

      // Prevent double trigger
      if (window.__PAYMENT_IN_PROGRESS__) return;
      window.__PAYMENT_IN_PROGRESS__ = true;

      const { method, planKey, billingType, currency } = e.detail;

      const endpoint =
        method === "paystack"
          ? "/payment/create-session"
          : "/stripe/create-checkout-session";

      try {
        const res = await api.post(endpoint, {
          plan: planKey,
          billing: billingType,
          currency,
        });

        const url = res.data?.checkoutLink;
        if (!url) throw new Error("Checkout URL missing");

        window.location.href = url;
      } catch (err) {
        window.__PAYMENT_IN_PROGRESS__ = false;
        alert(
          err.response?.data?.message ||
          err.message ||
          "Unable to start payment."
        );
      }
    };

    window.addEventListener("startPayment", handler);
    return () => window.removeEventListener("startPayment", handler);
  }, []);

  return null;
}
